import {
  NetworkRequestFailedError,
  BrokerNotConnectedError,
} from '../utils/customErrorTypes';
import { store } from '../utils/userStore';
import apiMap from '../utils/apiMap';

type HttpMethod = 'GET' | 'POST';

export const RequestType: { [M in HttpMethod]: M } = {
  GET: 'GET',
  POST: 'POST',
};

async function httpHandler<T>(
  method: HttpMethod,
  endpoint: string,
  data = {},
  customHeaders = {},
): Promise<T> {
  const headers = {
    'Content-Type': 'application/json',
    'x-sc-csrf': store.CSRF,
    ...customHeaders,
  };

  if (store.token) {
    headers['x-sc-gateway'] = store.token;
  }

  const requestOptions: RequestInit = {
    method,
    credentials: 'include',
    headers,
  };

  let finalUrl = `${BASE_URL}${store.gateway}${endpoint}`;
  if (method === 'GET') {
    // removing all undefined values like axios used to do https://github.com/axios/axios/issues/1139
    const params = new URLSearchParams(JSON.parse(JSON.stringify(data)));
    finalUrl = `${finalUrl}?${params.toString()}`;
  } else {
    requestOptions.body = JSON.stringify(data);
  }

  try {
    const response = await fetch(finalUrl, requestOptions);

    if (!response.ok) {
      if (response.status === 403) {
        throw new BrokerNotConnectedError(response);
      }
      throw new NetworkRequestFailedError(response);
    }

    const responseData = await response.json();
    if (endpoint === apiMap.SESSION_INIT || endpoint === apiMap.CONNECT) {
      store.token = responseData.data.gatewayToken;
    }

    return responseData;
  } catch (error) {
    if (
      error instanceof BrokerNotConnectedError ||
      error instanceof NetworkRequestFailedError
    ) {
      throw error;
    }
    throw new NetworkRequestFailedError(error);
  }
}

export default httpHandler;
